import React, { useEffect, useState } from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Axios from "axios";
import constants from "../../constants";
import InputMask from "react-input-mask";
import swal from "sweetalert";

let initialSettingsDatePicker = {
  minDate: "01/01/2015",
  maxDate: moment(new Date()),
  opens: "left",
  locale: {
    applyLabel: "Aplicar",
    fromLabel: "De",
    format: "DD/MM/YYYY",
    toLabel: "à",
    separator: " à ",
    cancelLabel: "Cancelar",
    customRangeLabel: "Data Customizada",
    daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
  },
  ranges: {
    Hoje: [moment(new Date())],
    Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Últimos 7 Dias": [moment().subtract(6, "days"), moment()],
    "Últimos 30 Dias": [moment().subtract(29, "days"), moment()],
    "Este Mês": [moment().startOf("month"), moment().endOf("month")],
    "Mês Passado": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
};

export default function Report() {
  const [paymentSolicitation, setPaymentSolicitation] = useState([]);
  const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment(new Date()).clone().add(1, "days").format("YYYY-MM-DD"));
  const [displayDate, setDisplayDate] = useState({});

  const [status, setStatus] = useState({
    aprovado: false,
    rejeitado: false,
    cancelado: false,
    pendente: false,
  });
  const [cpf, setCpf] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    // ACORDA HEROKU
    Axios.post("https://super-image-api.herokuapp.com/all-fast-report/").then(
      () => {}
    );

  }, []);

  function handleEvent(event, picker) {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.clone().add(1, "days").format("YYYY-MM-DD"));
    setDisplayDate({
      startDate: picker.startDate.format("DD/MM/YYYY"),
      endDate: picker.endDate.format("DD/MM/YYYY"),
    });
  }

  

  function handleList(params) {
    debugger
    let data = { startDate, endDate, status, cpf, displayDate };
    const url =
      constants().URL_SERVICE +
      "establishment/paymentrequest/filter_payment_requests/";

    setShowLoading(true);
    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        setShowLoading(false);
        setPaymentSolicitation(response.data.list);
      })
      .catch((error) => this.setState({ error: true }));
  }

  function exportReportPDF() {
    let data = {
      startDate,
      endDate,
      status,
      cpf,
      displayDate,
      date: moment().format("DD/MM/YYYY"),
      time: moment().format("LT"),
    };
    const url = "https://super-image-api.herokuapp.com/all-fast-report/";

    setShowLoading(true);

    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        // setShowLoading(false);
        // var win = window.open(response.data.path);
        // win.focus();
        setShowLoading(false);
        const el = document.createElement("div");
        el.innerHTML = `<a target="_blank" class="btn btn-primary" href='${response.data.path}'>Clique aqui para baixar o relatório em formato PDF.</a>`;

        swal({
          title: "Relatório de pagamento",
          content: el,
        });
      })
      .catch((error) => {
        setShowLoading(false);
        this.setState({ error: true });
      });
  }

  return (
    <div>
      <BarTitle name="Relatórios" />
      <div className="padder padder-top-30 ">
        <Painel className="">
          <div class="reports-search-painel">
            <div>
              <span className="sub-title">Período</span>
              <DateRangePicker
                initialSettings={initialSettingsDatePicker}
                onEvent={handleEvent}
              >
                <input type="text" className="form-control col-1 data-input" />
              </DateRangePicker>
            </div>

            <div>
              <div className="sub-title">CPF</div>
              <InputMask
                mask="999.999.999-99"
                value={cpf}
                onChange={(event, value) => {
                  setCpf(event.target.value);
                }}
                placeholder="Não obrigatório"
                className="form-control col-1 data-input"
              />
            </div>

            <div>
              <div className="sub-title">Status</div>
              <div class="checkbox-section">
                <input
                  type="checkbox"
                  onChange={() =>
                    setStatus({
                      ...status,
                      aprovado: !status.aprovado,
                    })
                  }
                  checked={status.aprovado}
                />
                <label for="outsidebar">Aprovado</label>
              </div>
              <div class="checkbox-section">
                <input
                  checked={status.rejeitado}
                  onChange={() =>
                    setStatus({
                      ...status,
                      rejeitado: !status.rejeitado,
                    })
                  }
                  type="checkbox"
                />
                <label for="outsidebar">Recusado</label>
              </div>
              <div class="checkbox-section">
                <input
                  checked={status.pendente}
                  onChange={() =>
                    setStatus({
                      ...status,
                      pendente: !status.pendente,
                    })
                  }
                  type="checkbox"
                />
                <label for="outsidebar">Pendente</label>
              </div>
              <div class="checkbox-section">
                <input
                  type="checkbox"
                  checked={status.cancelado}
                  onChange={() =>
                    setStatus({
                      ...status,
                      cancelado: !status.cancelado,
                    })
                  }
                />
                <label for="outsidebar">Cancelado</label>
              </div>
            </div>
            <div>
              <a onClick={handleList} type="button" class="btn btn-info">
                Listar
              </a>
              {paymentSolicitation.length > 0 && (
                <a type="button" class="btn btn-info" onClick={exportReportPDF}>
                  Exportar relatório
                </a>
              )}
            </div>
          </div>
        </Painel>
      </div>
      {/* <div className="padder">
        <Painel title="Dados do cliente / Dados solicitação pagamento" />
      </div> */}
      <div className="padder">
        <Painel title="Dados do cliente / Dados solicitação pagamento">
          <div className="table-wrap">
            <table className="table table-striped">
              <thead>
                {!showLoading && paymentSolicitation.length > 0 && (
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Descrição</th>
                    <th>Status</th>
                  </tr>
                )}
              </thead>
              <tbody>
                {!showLoading &&
                  paymentSolicitation.map((solicition, i) => (
                    <tr>
                      <td> {solicition.id} </td>
                      <td>
                        <b>Nome: </b>
                        {solicition.client.name}
                        <br />
                        <b>CPF: </b>
                        {solicition.client.cpf}
                        <br />
                        <b>Email: </b>
                        {solicition.client.email}
                        <br />
                        <b>Telefone: </b>
                        {solicition.client.phone}
                      </td>
                      <td style={{ width: "600px" }}>
                        <b>Valor: </b>
                        {solicition.price}
                        <br />
                        <b>Data e hora: </b>
                        {solicition.date} - {solicition.time}
                        <br />
                        <b>Descrição: </b>
                        {solicition.description}
                      </td>

                      <td>
                        {solicition.status == 0 ? (
                          <label className="label bg-warning m-l-xs">
                            Pendente
                          </label>
                        ) : null}

                        {solicition.status == 1 ? (
                          <label className="label bg-success m-l-xs">
                            Aprovado
                          </label>
                        ) : null}

                        {solicition.status == 2 ? (
                          <label className="label bg-danger m-l-xs">
                            Recusado
                          </label>
                        ) : null}
                        {solicition.status == 3 ? (
                          <label className="label bg-danger m-l-xs">
                            Cancelado
                          </label>
                        ) : null}
                      </td>
                    </tr>
                  ))}
              </tbody>
              <div className="no-result">
                {paymentSolicitation.length == 0 && !showLoading && (
                  <h3>Nenhum resultado encontrado</h3>
                )}
                {showLoading && (
                  <img
                    width="25"
                    height="25"
                    src="https://static1.deway.com.br/allfast/loading-loading-forever.gif"
                  ></img>
                )}
              </div>
            </table>
          </div>
        </Painel>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Reports/index.js